/* eslint-disable func-names */
import { channel } from 'redux-saga';
import {
  takeEvery, takeLatest, fork, put,
} from 'redux-saga/effects';

export default function takeLatestPerProps(propsOrSelectors, pattern, worker, ...args) {
  return fork(function* () {
    const channels = {};
    yield takeEvery(pattern, function* (action) {
      let scope = action.type;
      propsOrSelectors.forEach((selector) => {
        scope = `${scope}_${action.payload[selector]}`;
      });
      if (!channels[scope]) {
        channels[scope] = channel();
        yield takeLatest(channels[scope], worker, ...args);
      }
      yield put(channels[scope], action);
    });
  });
}
